import { Menu } from 'src/app/shared/models/menu.model';
import { environment } from '../../../environments/environment';

export const MENU: Menu[] = [
  {
    name: 'Dashboard',
    icon: 'dashboard.svg',
    activeIcon: 'dashboard_active.svg',
    subMenu: [
      {
        name: 'Project Summary',
        path: '/dashboard',
      },
    ],
  },
  {
    name: 'Project Menu',
    icon: 'project.svg',
    activeIcon: 'project_active.svg',
    subMenu: [
      {
        name: 'Project',
        type: 'dropdown',
      },
      {
        name: 'Dashboard',
        path: '/project-dashboard',
      },
      {
        name: 'Reports',
        path: '/report/reports-menu',
      },
      ...(environment.enableAnnouncement
        ? [
            {
              name: 'Announcement',
              path: '/project-announcement',
            },
          ]
        : []),
      {
        name: 'Check-in & Check-out',
        path: '/check-in/all',
        property: 'check_in_check_out',
      },
      {
        name: 'Roster Plan',
        path: '/roster-plan/view',
        property: 'roster_plan',
      },
      {
        name: 'Leave Request',
        path: '/leave-request/all',
        property: 'leave_request',
      },
      {
        name: 'OT Request',
        path: '/ot-request/all',
        property: 'ot_request',
      },
      {
        name: 'Track route & Pinpoint',
        path: '/route/track-route',
        property: 'track_route_pin_point',
      },
      {
        name: 'Merchandizer & Sales Report',
        path: '/merchandizer/merchandizer-information',
        property: 'merchandizer',
      },
      {
        name: 'Event Stock',
        path: '/event/event-stock',
        property: 'event_stock',
      },
      {
        name: 'To-Do List',
        path: '/todo',
        property: 'todo',
      },
      {
        name: 'Survey',
        path: '/survey',
        property: 'survey',
      },
      {
        name: 'Upload & Document',
        path: '/upload',
        property: 'upload',
      },
      {
        name: 'Employee Data',
        path: '/employee',
      },
      {
        name: 'Workplace Data',
        path: '/workplace',
      },
    ],
  },
  {
    name: 'Ahead Management',
    icon: 'ahead_management.svg',
    activeIcon: 'ahead_management_active.svg',
    subMenu: [
      {
        name: 'Client Management',
        path: '/client',
      },
      {
        name: 'Project Management',
        path: '/projects',
      },
      {
        name: 'User Management',
        path: '/user',
      },
      ...(environment.enableAnnouncement
        ? [
            {
              name: 'Announcement',
              path: '/announcement',
            },
          ]
        : []),
    ],
  },
  {
    name: 'Ahead User',
    icon: 'adecco_user_icon.svg',
    activeIcon: 'adecco_user_icon_active.svg',
    subMenu: [
      {
        name: 'Adecco User Management',
        path: '/manage-user',
      },
      {
        name: 'Branch Management',
        path: '/manage-branch',
      },
      {
        name: `Adecco's Calendar`,
        path: '/adecco-calendar',
      },
    ],
  },
];

export const PROFILE = {
  name: 'Profile',
  subMenu: [
    {
      name: 'Profile',
      path: '/profile',
    },
    {
      name: 'Change Password',
      path: '/change-password',
    },
  ],
};
